<template>
  <div>
    <div v-if="loading_page === true">
      <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
        <v-skeleton-loader type="article, actions"></v-skeleton-loader>
      </v-sheet>
    </div>
    <div v-if="loading_page === false">
      <v-card elevation="6" class="mb-10">
        <div class="pa-3">
          <div>
            <div class="">
              <div class="mt-3 mr-1">
                <div class="d-flex">
                  <div class="ml-1" style="font-size: 22px">รายละเอียดสินค้า</div>
                </div>
                <div class="mt-6 grid_img">
                  <div class="ml-4">
                    <v-img height="200" width="200" max-width="200" v-if="imagePreviewURL == null" :lazy-src="img_holder" :src="img_holder" class="preview mx-auto"></v-img>
                    <v-img height="200" width="200" max-width="200" v-if="imagePreviewURL != null" :lazy-src="img_holder" :src="imagePreviewURL" class="preview mx-auto"></v-img>
                  </div>
                </div>
              </div>
            </div>
            <div class="mt-3 mr-1" v-if="picmores.length > 0">
              <div class="d-flex">
                <div class="ml-1" style="font-size: 22px">รูปภาพเพิ่มเติม</div>
              </div>
              <div class="grid_sub_image">
                <div class="mt-6 grid_img" v-for="(data, index) in  this.picmores" :key="index">
                  <div class="ml-4">
                    <v-img height="200" width="200" max-width="200" v-if="data.picture === ''" :lazy-src="img_holder" :src="img_holder" class="preview mx-auto"></v-img>
                    <v-img height="200" width="200" max-width="200" v-if="data.picture !== ''" :lazy-src="data.picture" :src="data.picture" class="preview mx-auto"></v-img>
                  </div>
                </div>
              </div>
            </div>
            <div class="d-flex mt-4">
              <div class="ml-1" style="font-size: 22px"></div>
            </div>
            <div class="grid_half">
              <div>
                <div class="ml-2">ชื่อสินค้า</div>
                <div class="ma-2 ml-3 grey--text" style="font-size: 18px">
                  {{ getProduct_list.name }}
                </div>
              </div>
              <div class="">
                <div class="ml-2">ชื่อทางการแพทย์</div>
                <div class="ma-2 ml-3 grey--text" style="font-size: 18px" v-if="getProduct_list.name_sci != null && getProduct_list.name_sci != 'null'">{{ getProduct_list.name_sci }}</div>
                <div class="ma-2 ml-3 grey--text" style="font-size: 18px" v-else>-</div>
              </div>

              <div>
                <div class="ml-2">ประเภทสินค้า</div>
                <div class="ma-2 ml-3 grey--text" style="font-size: 18px">
                  {{ getProduct_list.product_type_name }}
                </div>
              </div>
              <div class="">
                <div class="ml-2">บริษัท/Supplier</div>
                <div class="ma-2 ml-3" style="font-size: 18px">
                  <div v-for="(detail, index) in getSupplier_list" :key="index">
                    <span class="grey--text">{{ detail.sup_name }}</span>,
                  </div>
                </div>
              </div>

              <div>
                <div class="ml-2">จำนวนสินค้าไม่ควรน้อยกว่า</div>
                <div class="ma-2 ml-3" style="font-size: 18px"><span class="grey--text">{{ getProduct_list.min_qty }}</span> หน่วย</div>
              </div>
            </div>
            <div class="grid_full mt-4 ml-2">
              <div>รายละเอียด</div>
              <div class="ma-1" style="font-size: 18px" v-if="getProduct_list.detail != null && getProduct_list.detail != 'null'"><span class="grey--text">{{ getProduct_list.detail }}</span></div>
              <div class="ma-1" style="font-size: 18px" v-else><span class="grey--text">-</span></div>
            </div>
            <div class="">
<!--              <div class="mt-3 ml-1">-->
<!--                <div class="d-flex align-center">-->
<!--                  <v-checkbox color="#86bc3a" class="ma-4 ml-6" v-model="getProduct_list.claim_status" hide-details="auto" disabled></v-checkbox>-->
<!--                  <div class="grid_full" style="font-size: 16px">-->
<!--                    ลูกค้าส่งสามารถเครมสินค้าหมดอายุได้-->
<!--                  </div>-->
<!--                </div>-->
<!--              </div>-->
              <div class="mt-3">
                <div class="ml-2">เงื่อนไขการเคลมสินค้า</div>
                <div class="ma-2 ml-3" style="font-size: 18px"><span class="grey--text">{{ getProduct_list.condition_id }}</span></div>
              </div>
              <div class="mt-3">
                <div class="ml-2">หมายเหตุ</div>
                <div class="ma-2 ml-3" style="font-size: 18px" v-if="getProduct_list.note != null"><span class="red--text">{{ getProduct_list.note }}</span></div>
                <div class="ma-2 ml-3" style="font-size: 18px" v-else><span class="red--text">-</span></div>
              </div>
            </div>
          </div>
        </div>
        <v-divider class="mt-2 ml-4 mr-4"/>
        <div class="pa-3 pb-6">
          <v-form @submit.prevent="">
            <div class="mt-3 mr-1">
              <div class="d-flex">
                <div class="ml-1">ข้อมูลหน่วยนับ</div>
              </div>
            </div>
            <div class="mb-n5">
              <small style="color:red;">* หน่วยหลัก</small>
            </div>
            <div class="grid_col mt-5">
              <div>
                <div class="ml-2" style="font-size: 16px">หน่วยนับ</div>
                <div class="ml-4 mr-4">
                  <div class="mt-4 mr-4 grey--text" v-if="unit_main.unit_name !== null">{{ unit_main.unit_name }}</div>
                  <div class="mt-4 mr-4 grey--text" v-else>-</div>
                </div>
              </div>
              <div>
                <div class="ml-2" style="font-size: 16px">บาร์โค้ด</div>
                <div class="ml-4 mt-4 mr-4 grey--text" v-if="unit_main.barcode !== null">{{ unit_main.barcode }}</div>
                <div class="ml-4 mt-4 mr-4 grey--text" v-else>-</div>
              </div>
              <div>
                <div class="ml-2" style="font-size: 16px">น้ำหนัก(กิโลกรัม)</div>
                <div class="ml-4 mt-4 mr-4 grey--text" v-if="unit_main.weight !== null">{{ unit_main.weight }}</div>
                <div class="ml-4 mt-4 mr-4 grey--text" v-else>0</div>
              </div>
              <div>
                <div class="ml-2" style="font-size: 16px">จำกัดการซื้อห้ามเกิน</div>
                <div class="ml-4 mt-4 mr-4 grey--text" v-if="unit_main.limit_purchase !== null">{{ unit_main.limit_purchase }}</div>
                <div class="ml-4 mt-4 mr-4 grey--text" v-else>0</div>
              </div>
            </div>
            <div v-for="(unit,index) in getUnit_list" :key="index">
              <div class="grid_col mt-5">
                <div>
                  <div class="ml-2" style="font-size: 16px">หน่วยนับ</div>
                  <div class="ml-4 mr-4">
                    <div class="mt-4 mr-4 grey--text" v-if="unit.unit_name != null">{{ unit.unit_name }}</div>
                    <div class="mt-4 mr-4 grey--text" v-else>-</div>
                  </div>
                </div>
                <div>
                  <div class="ml-2" style="font-size: 16px">บาร์โค้ด</div>
                  <div class="ml-4 mt-4 mr-4 grey--text" v-if="unit.barcode != null">{{ unit.barcode }}</div>
                  <div class="ml-4 mt-4 mr-4 grey--text" v-else>-</div>
                </div>
                <div>
                  <div class="ml-2" style="font-size: 16px">น้ำหนัก(กิโลกรัม)</div>
                  <div class="ml-4 mt-4 mr-4 grey--text" v-if="unit.weight != null">{{ unit.weight }}</div>
                  <div class="ml-4 mt-4 mr-4 grey--text" v-else>0</div>
                </div>
                <div>
                  <div class="ml-2" style="font-size: 16px">จำกัดการซื้อห้ามเกิน</div>
                  <div class="ml-4 mt-4 mr-4 grey--text" v-if="unit.limit_purchase != null">{{ unit.limit_purchase }}</div>
                  <div class="ml-4 mt-4 mr-4 grey--text" v-else>0</div>
                </div>
              </div>
            </div>
          </v-form>
        </div>
      </v-card>
    </div>
  </div>
</template>

<script src="@/previewimage.js"></script>
<script>
import img_holder from "@/assets/pharmacy.png";
import {HTTP} from "@/axios";
import Swal from "sweetalert2";

export default {
  name: "Product_details",
  inject: {
    theme: {
      default: {
        isDark: false
      },
    },
  },
  data() {
    return {
      checkbox: null,
      img_holder: img_holder,
      pro_pic_name: null,
      imagePreviewURL: null,
      loading_page: false,
      name: null,
      // { id: 1, name: '30 วัน' },
      // { id: 2, name: '90 วัน' },
      items: [
        { id: 0, name: 'ไม่มี'},
        { id: 3, name: '120 วัน' },
        { id: 4, name: '240 วัน' },
        { id: 5, name: '365 วัน' },
      ],
      typeItems: [
        { id: 1, name: 'กล่อง' },
        { id: 2, name: 'แพ็ค' },
        { id: 3, name: 'แผง' },
        { id: 4, name: 'เม็ด' },
      ],
      unit_id: 1,
      getProduct_list: {
        id: null,
        claim_status: null,
        condition_id: null,
        detail: null,
        min_qty: null,
        name: null,
        name_sci: null,
        product_code: null,
        product_type: null,
        product_type_name: null,
        note: null,
      },
      unit_main: [],
      getSupplier_list: [],
      getUnit_list: [],
      getType_product: [],
      getType_supplier: [],
      type_unit: [],
      picmores: [],
    }
  },
  methods: {
    onFileChange(payload) {
      const file = payload
      if (file) {
        this.imagePreviewURL = URL.createObjectURL(file)
        URL.revokeObjectURL(file)
      } else {
        this.imagePreviewURL = null
      }
    },
    addUnit() {
      const id = this.getUnit_list.length += 1;
      this.getUnit_list.push({
        "id": id,
        "unit_type": null,
        "barcode": null,
        "weight": null,
        "limit_purchase": null,
      })
    },
    deleteUnit(id) {
      this.getUnit_list = this.getUnit_list.filter(detail => detail.id !== id)
    },
    getSupplier_type() {
      HTTP.post('/suppliers/all')
          .then((res) => {
            if (res.data.success === true){
              this.getType_supplier = res.data.object.map((obj) => {
                return {
                  sup_id: obj.id,
                  sup_name: obj.name
                }
              });
            }
          })
    },
    getProduct() {
      this.loading_page = true;
      const id = this.$route.params.id;
      HTTP.post('/products/product/show/' + id)
          .then((res) => {
            if (res.data.success === true) {
              this.loading_page = false;
              this.getProduct_list.id = res.data.product.id
              this.getProduct_list.claim_status = res.data.product.claim_status
              const value = this.items.find((data) => data.id == res.data.product.condition_id)
              this.getProduct_list.condition_id = value.name
              this.getProduct_list.detail = res.data.product.detail
              this.getProduct_list.min_qty = res.data.product.min_qty
              this.getProduct_list.name = res.data.product.name
              this.imagePreviewURL = res.data.product.picture
              this.getProduct_list.name_sci = res.data.product.name_sci
              this.getProduct_list.product_code = res.data.product.product_code
              this.getProduct_list.product_type = res.data.product.product_type
              this.getProduct_list.product_type_name = res.data.product.product_type_name
              this.getProduct_list.note = res.data.product.note
              this.getUnit_list = res.data.product_list
              this.unit_main = res.data.unit_main
              this.getSupplier_list = res.data.product_supplier
              this.picmores = res.data.picmores
              console.log(res.data)
            }else{
              Swal.fire({
                text: res.data.message,
                icon: 'error',
                showDenyButton: false,
                showCancelButton: false,
                confirmButtonText: `ตกลง`,
                denyButtonText: `ยกเลิก`,
              }).then(() => {
                this.$router.push('/stock/manage_product/productlist')
              })
            }
          })
    },
    get_unit() {
      HTTP.get('/products/units/all')
          .then((res) => {
            if (res.data.success === true){
              this.type_unit = res.data.object;
            }
          })
    },
    checkLogIn() {
      let id = this.$route.params.id;
      if (this.$route.path == '/stock/manage_product/productdetails/' + id) {
        if (this.$store.state.userDetail.manage_product_list !== 1) {
          this.$router.push('/stock/manage_product/productlist')
        }
      }
    }
  },
  beforeMount() {
    this.checkLogIn();
  },
  mounted() {
    this.getProduct();
    this.getSupplier_type();
    this.get_unit();
  }
}
</script>

<style scoped>
.grid_half {
  display: grid;
  grid-template-columns: 50% 50%;
}
.grid_col {
  display: grid;
  grid-template-columns: 25% 25% 25% 25%;
  grid-gap: 15px 0;
}
.grid_img {
  display: grid;
  grid-template-columns: 25% 85%;
}
.preview {
  border-radius: 8px;
}
.grid_full {
  display: grid;
  grid-template-columns: 100%;
}
.grid_row_image {
  display: grid;
  grid-template-columns: 25% 75%;
}
.grid_sub_image {
  display: grid;
  grid-template-columns: 25% 25% 25% 25%;
}
@media only screen and (max-width: 1100px) {
  .grid_img {
    display: grid;
    grid-template-columns: 100%;
  }
  .grid_half {
    display: grid;
    grid-template-columns: 50% 50%;
  }
  .grid_col {
    display: grid;
    grid-template-columns: 50% 50%;
    grid-gap: 15px 0;
  }
  .grid_sub_image {
    display: grid;
    grid-template-columns: 33.33% 33.33% 33.33%;
  }
}
@media only screen and (max-width: 768px) {
  .grid_col {
    display: grid;
    grid-template-columns: 100%;
    grid-gap: 15px 0;
  }
  .grid_half {
    display: grid;
    grid-template-columns: 100%;
  }
  .grid_sub_image {
    display: grid;
    grid-template-columns: 100%;
  }
}
</style>
